import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { windowSelectors } from 'models/window'
import { Modal } from './modal'
import { modalNames } from './constants/names'
import ContactModal from '../../contact-modal/contact-modal'
import SentModal from "../../sent-modal/sent-modal";

export const Modals = () => {
    const name = useSelector(windowSelectors.name)
    const props = useSelector(windowSelectors.props)

    const [template, setTemplate] = useState(null)

    useEffect(() => {
        if (name) {
            switch (name) {
                case modalNames.CONTACT_MODAL:
                    setTemplate(<ContactModal />)
                    break
                case modalNames.SENT_MODAL:
                    setTemplate(<SentModal />)
                    break

                default:
                    setTemplate(null)
            }
        }
    }, [name, props])

    return <Modal opened={!!name}>{template}</Modal>
}
